import Vue from 'vue'
import Question from '../../models/question'
import { Component, Prop } from 'vue-property-decorator'
import { LETTER_FORMAT } from '../../utils/constants'
import { questionServiceParser, answerItemBodyParser } from '../../../../helpers/question-parser'
import Skill from '../../models/skill'
import SkillItem from '../../models/skill_item'
import { map } from 'lodash'
import markdownParser from '../../../../helpers/markdown-parser'
import { createTooltipText } from '../../utils/tooltip'
import UserExam from '../../models/user_exam'
import Exam from '../../models/exam'
import {
  resetStyleMathLive,
  checkMathLiveExist,
  createMathliveField
} from '../../../../lib/mathlive'
import SchoolSetting from '../../../api/v2/models/school_setting'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'
import { format } from 'date-fns'
import { processAudioSpeak } from '../../../../lib/speak_polly'

@Component
export default class ExamResultQuestionBodyMixin extends Vue {
  @Prop({ required: true }) groupIndex: number
  @Prop({ required: true }) currentQuestion: Question
  @Prop({ required: true }) index: number
  @Prop({required: true}) schoolSetting: SchoolSetting
  @Prop({ required: true })
  exam!: Exam

  @Prop({ required: true })
  userExam!: UserExam

  @Prop({ default: false })
  isMultipleQuestion!: boolean

  @Prop({ default: null })
  examQScoreHistory!: ExamQScoreHistory | null

  markdownParser = markdownParser
  LETTER_FORMAT = LETTER_FORMAT
  // Audioのため、mounted1/10秒のあとに、viewを実行します。やらないと、IOSで体重問題発生します。
  show = false

  mounted() {
    this.show = false
    setTimeout(() => {
      this.show = true
    }, 100)

    resetStyleMathLive()
  }

  get qScoreHistorySummary(){
    if (!this.examQScoreHistory) {
      return null
    }

    return this.examQScoreHistory.getQScoreHistorySummary(this.currentQuestion.id)
  }

  dateFormat(date: Date) {
    return format(date, 'YYYY/MM/DD')
  }

  get userScore() {
    return this.currentQuestion.userScore
  }

  get maxScore() {
    return this.currentQuestion.maxScore
  }

  getRateScore(score, maxScore) {
    if(maxScore == 0) {
      return 0
    } 
    return Math.round(score*100/maxScore)
  }
  
  get score(): number {
    return this.currentQuestion.getScoreByUserExam(this.userExam)
  }

  get isPass() {
    return this.score === this.currentQuestion.maxScore
  }

  get isNotFullScore() {
    return this.score < this.currentQuestion.maxScore && this.score > 0
  }

  get isNotPass() {
    return this.score === 0
  }

  get explanation(): string {
    return !this.currentQuestion.explanation ? '' : markdownParser(this.currentQuestion.explanation)
  }

  get content(): string {
    if (!this.currentQuestion) {
      return ''
    }

    setTimeout(() => {
      if (this.currentQuestion.isTextfield) {
        (document
          .getElementById(`question_${this.currentQuestion.id}`)
          .querySelectorAll('.textfield-question') as any).forEach((element: HTMLInputElement, index) => {
          element.value = this.value[index] || ''

          // Set answer for textfield
          const answerItem = this.currentQuestion.answerItems[index]

          let neoElement = null
          if (checkMathLiveExist(answerItem.body)) {
            neoElement = createMathliveField(element, false)
            neoElement.parentElement.parentElement.style.paddingBottom = '18px'
          } else {
            neoElement = element
          }

          setTimeout(() => {
            const htmlText = answerItem ? answerItemBodyParser(answerItem.body) : ''
            const resultClass =
              answerItem && answerItem.correctValue(element.value, this.currentQuestion.isTextfield)
                ? 'right'
                : 'wrong'
            createTooltipText(htmlText, neoElement, `textfield-question-answer ${resultClass}`)
          }, 100)
        })
      }

      if (this.currentQuestion.isInlineSelect) {
        (document
          .getElementById(`question_${this.currentQuestion.id}`)
          .querySelectorAll('.inline-select-question') as any).forEach((element: HTMLSelectElement, index) => {
          Array.prototype.forEach.call(element.options, (option: HTMLOptionElement) => {
            if (option.value == this.value[index]) {
              option.selected = true
            }

            const answerItems = this.currentQuestion.answerItemScopes[index]
            if (answerItems) {
              const correctAnswerItems = answerItems.filter(answerItem => answerItem.correct)
              const htmlText = correctAnswerItems.map(answerItem => answerItemBodyParser(answerItem.body)).join(', ')
              const resultClass =
                correctAnswerItems.length &&
                correctAnswerItems.every((answerItem) => answerItem.body !== this.value[index])
                  ? 'wrong'
                  : 'right'
              createTooltipText(htmlText, element, `textfield-question-answer ${resultClass}`)
            }
          })
        })
      }

      // Text - Speak 実行
      processAudioSpeak(document.getElementById(`question_${this.currentQuestion.id}`))
    }, 100)
    const content = this.currentQuestion.body.split('<a ').join('<a target="_blank" ')
    return questionServiceParser(content, this.currentQuestion, true)
  }

  get value(): string[] {
    // ユーザー提出したあとに、UseExamにanserItemがありまので、そちにみないといけません（複数UserExamができますので、質問内にはテスト中のAnswerItemのみです）
    return this.userExam.finishedAt ? this.currentQuestion.getAnswerValue(this.exam.answersFlowQuestion(this.userExam)) : this.currentQuestion.answerValues
  }

  getNameByExamType(type){
    switch (type) {
      case Exam.TYPE_USE_NIGATE_EXAM:
        return `ニガテ質問を再テスト`
      case Exam.TYPE_USE_SPECIAL_EXAM:
        return `別質問を再テスト`
      case Exam.TYPE_USE_EXAM_FROM_FAILED:
        return `間違った質問を再テスト`
      default:
        return `同じ質問再テスト`
    }
  }

  skillItemsName(skill: Skill): string {
    const skillItems = skill.skillItems.filter((skillItem) =>
      this.currentQuestion.skillItems.some((item) => item.id == skillItem.id)
    )
    return this.getSkillsName(skillItems)
  }

  getSkillsName(skills: Skill[] | SkillItem[]) {
    return map(skills, 'name').join(', ')
  }
}
